export default __webpack_public_path__ + "static/media/r6.c6969ead.jpeg";